<template>
    <cis-head
        :title="$page.props.title"
    />
    <v-app
        id="root"
    >
        <notifications position="bottom left">
            <template #body="props">
                <v-sheet
                    class="pa-3 pl-4 text-black border-s-lg  mt-0 elevation-5 ma-4 cursor-pointer"
                    :class="`notification-${props.item.type}`"
                    color="grey-lighten-3"
                    rounded
                    max-width="400"
                    @click="props.close()"
                >
                    <h4 v-if="props.item.title " class="text-h5 font-weight-bold mb-1">{{ props.item.title }}</h4>
                    <div class="d-flex ga-2">
                        <div v-html="props.item.text"></div>
                    </div>

                </v-sheet>
            </template>
        </notifications>
        <app-bar
            :menu="menu"
            :menu-model="menuModel"
            :active-menu="activeMenu"
            @mobile-menu-state="changeMobileMenuState"
            @info-bar="heightInfoBar"
            :mobile-menu-open="mobileMenuState"
        >
            <template #append>
                <div v-if="!$page.props.simplePage" id="app-bar-middle-wrap" class="d-flex align-center flex-grow-1">
                    <search-bikes
                        class="flex-1-1-100 flex-lg-0-1"
                        :model-search="$page.props.modelSearch"
                        :searched-bikes="$page.props.searchedBikes"
                        :heightInfoBar="infoHeight"
                    ></search-bikes>
                    <v-divider
                        v-show="$vuetify.display.smAndDown"
                        vertical
                        color="grey-lighten-2"
                        class="border-opacity-100"
                    ></v-divider>
                    <search
                        :show="true"
                        :mobile="false"
                        :heightInfoBar="infoHeight"
                        class="flex-1-1-100"
                    >
                    </search>
                </div>
            </template>
        </app-bar>
        <mobile-menu
            v-if="mobileMenuState"
            :menu="menu"
            :menu-model="menuModel"
            :active-menu="activeMenu"
            :heightInfoBar="infoHeight"
            @close="changeMobileMenuState(false)"
        ></mobile-menu>
        <div class="c-overlay search-included" :class="{'has-overlay': overlayStore.overlayMenu}" @click="() => {
            overlayModalsStore.modelSearchOpen = false;
        }"></div>
        <v-main id="main" name="main" class="bg-grey-lighten-5" :class="{
            'has-overlay': overlayStore.overlayMenu,
            'is-narrow': isNarrow
        }">
            <div class="main-content">
                <breadcrumb
                    v-if="!group?.id && !searching && !$page.props.page_obj?.contact && !$page.props.hide_breadcrumbs"
                    :items="$page.props.breadcrumb"
                    :style="$page.props.thin ? 'max-width: 1130px; margin: 0 auto':''"></breadcrumb>
                <slot></slot>
            </div>
        </v-main>
        <lazy-hydration-wrapper v-if="!$page.props.simplePage" :when-visible="{ rootMargin: '150px' }"
                                @hydrated="footerInit = true">
            <app-footer :key="footerInit" :class="{'has-overlay': overlayStore.overlayMenu}"
                        @showModalCookie="showModalCookie"></app-footer>
        </lazy-hydration-wrapper>
        <component v-if="$page.props.user.token" :is="liveEdit"></component>
        <newsletter-el v-if="showNewsletter" :show="showNewsletter" v-bind="newsletterProps"
                       @close="showNewsletter = false"></newsletter-el>
        <v-dialog
            v-model="addToCartDialog"
            persistent
        >
            <cart-modal
                :toBuy="addToCart?.toBuy"
                :order="addToCart?.order"
                @close="addToCartDialog = false"
            ></cart-modal>
        </v-dialog>
    </v-app>
</template>

<script setup>

import CisHead from "../../components/CisHead.vue";
import {router, usePage} from "@inertiajs/vue3";
import Search from "../components/Search.vue";
import {LazyHydrationWrapper} from "vue3-lazy-hydration";
import {useNotify} from "../../../../../Modules/Admin/Resources/assets/js/composables/notify";
import pinia from "../../../plugins/pinia";
import {
    computed,
    defineAsyncComponent,
    inject,
    nextTick,
    ref,
    watch
} from "vue";
import axios from "axios";
import AppBar from "../components/AppBar.vue";
import Breadcrumb from "../components/Breadcrumb.vue";
import SearchBikes from "../components/SearchBikes.vue";
import AppFooter from "../components/AppFooter.vue";
import {useOverlayStore} from "../components/store/overlay";
import MobileMenu from "../components/MobileMenu.vue";
import categoryCountStore from "../../../../../Modules/Eshop/Resources/js/composables/categoryCountStore.js";
import {useOverlayModalsStore} from "../components/store/overlayModals.js";
import {useSearchStore} from '../components/store/search.js';

useNotify();
const route = inject('route');

const footerInit = ref(false);

const liveEdit = defineAsyncComponent(() => import('./../../components/LiveEdit.vue'));
const newsletterEl = defineAsyncComponent(() => import('./../../components/Newsletter.vue'));

const addToCart = computed(() => usePage().props.addToCart);
const addToCartDialog = ref(false);
const CartModal = defineAsyncComponent(() => import('../../../motonet/modules/eshop/frontend/CartModal.vue'));

const categoryCount = categoryCountStore(pinia);
const overlayStore = useOverlayStore(pinia);
const overlayModalsStore = useOverlayModalsStore(pinia);
const showModalCookie = async () => {
    const script = document.getElementById('cookieScript');
    const modal = document.getElementById('modal-cookie')
    if (!script) {
        const {data} = await axios.get('/get-cookie-settings');
        document.body.insertAdjacentHTML('beforeend', data.html);
        document.head.append(document.createRange().createContextualFragment(data.script));
    }
    if (!modal) {
        const response = await fetch('/get-cookie-modal');
        const data = await response.json();
        document.body.insertAdjacentHTML('beforeend', data.html);
        window?.laravelCookieConsent.initButtons();
    }
    window?.laravelCookieConsent.modalShow();
}

const user = computed(() => usePage().props.customer);
const menu = computed(() => {
    return usePage().props.menuGroups;
});
const mobileMenuState = ref(false);
const infoHeight = ref(0);
const heightInfoBar = (val) => {
    infoHeight.value = val;
}
const changeMobileMenuState = (state) => {
    mobileMenuState.value = state;
}

const group = computed(() => usePage().props.group);
const searching = computed(() => usePage().props.globalBreadcrumbOverride);
const menuModel = ref(group.value?.path_ids || []);

watch(() => group.value?.path_ids, (val) => {
    menuModel.value = val;
})

watch(addToCart, (val) => {
    addToCartDialog.value = !!val;
})

const activeMenu = computed(() => {
    const active = {};
    if (group.value) {
        for (let i = 0; i < menu.value.length; i++) {
            if (group.value.path_ids.includes(menu.value[i].id)) {
                active[menu.value[i].id] = true;
            }
            if (menu.value[i].children) {
                for (let j = 0; j < menu.value[i].children.length; j++) {
                    if (group.value.path_ids.includes(menu.value[i].children[j].id)) {
                        active[menu.value[i].children[j].id] = true;
                        return active;
                    }
                }
            }
        }
    }
    return active;
})

nextTick(() => {
    if (!import.meta.env.SSR) {
        document.body.classList.remove('d-none');
    }
})
axios.interceptors.request.use(
    config => {
        const token = user.value?.token;
        if (token) {
            config.headers['Authorization'] = 'Bearer ' + token;
        }
        return config;
    },
    error => {
        return Promise.reject(error)
    });
let first = true;
if (!import.meta.env.SSR) {
    router.on('navigate', () => {
        if (!first) {
            window.resetDL();
        }
        first = false;
    })
}

const showNewsletter = ref(false);
const newsletterProps = ref({});

const isNarrow = computed(() => {
    return usePage().props.type === 'register' || usePage().props.type === 'narrow';
})

const searchStore = useSearchStore(pinia);

watch([() => usePage().props.modelSearch?.model?.id, () => usePage().props.group?.id, () => usePage().props.manufacturer?.id], ([newModelId, newGroupId, manufacturer]) => {
    if (!import.meta.env.SSR) {
        let ids = newGroupId;
        if (usePage().props.subgroups?.length) {
            ids = usePage().props.subgroups.map(({id}) => id);
        }
        let query;
        if (route().current('search.view')) {
            query = searchStore.query;
        }
        categoryCount.loadCounts(ids, query, manufacturer)
    }
}, {immediate: true})
</script>

<style scoped lang="scss">
@use '../../../plugins/vuetify-settings' as *;
@use 'vuetify/lib/styles/settings/variables' as *;
@use 'vuetify/lib/components/VOverlay/variables' as *;
@use 'sass:map';

.c-overlay {
    //transition: opacity .3s $standard-easing;
    background-color: #000;
    opacity: 0;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    pointer-events: none;
    height: 100%;

    &.has-overlay {
        opacity: $overlay-opacity;
        z-index: 100;
        pointer-events: all;

        & ~ * {
            pointer-events: none;
        }
    }
}

#app-bar-middle-wrap {
    @media #{map.get($display-breakpoints, 'md-and-up')} {
        gap: $spacer * 2;
    }
}


.v-main {
    &.is-narrow {
        display: flex;
        flex-direction: column;
        align-items: center;

        .main-content {
            width: 1130px;
            max-width: 100%;
        }
    }
}
</style>
<style>
.animation-rotate {
    animation: rotation 2s linear infinite;
}

@keyframes rotation {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}

</style>
